// extracted by mini-css-extract-plugin
export default {"hideEllipses":"subscribe_hideEllipses__Rhref","hideBreak":"subscribe_hideBreak__cI1fE","subscribe_text":"subscribe_subscribe_text__P8k+v"};